// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2U_Gu","insightsList":"newBusinessInsightsMenu_insightsList__Wnw37","active":"newBusinessInsightsMenu_active__Qh4Me"};